import * as React from "react";
import InfoCardContent from "./InfoCardContent";

export interface CardProps {
  type: "vku" | "plus" | null;
  logo?: string;
  title?: string;
  content?: string;
  className?: string;
  subContent?: string;
  children?: React.ReactNode;
}

export function InfoCard({
  type,
  title,
  logo,
  content,
  children,
  subContent,
  className = "",
}: React.PropsWithChildren<CardProps>) {
  return (
    <div className={`flex bg-white rounded-3xl shadow-lg  ${className}`}>
      {children}
      <InfoCardContent
        title={title}
        logo={logo}
        content={content}
        subContent={subContent}
        type={type}
      />
    </div>
  );
}
